import Reveal from "@/components/Reveal";

const tanks = [
  { count: "3 ×", size: "15,000 KL", testId: "tank-15000" },
  { count: "2 ×", size: "2,000 KL", testId: "tank-2000" },
  { count: "1 ×", size: "1,000 KL", testId: "tank-1000" },
];

const Facility = () => (
  <section id="facility" data-testid="facility-section" className="scroll-mt-20 bg-ujn-deep text-ujn-offwhite">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-8">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-subtle">OUR FACILITY</p>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
              INSTALLED STORAGE CAPACITY
            </h2>
          </Reveal>

          <p
            data-testid="facility-main-stat"
            className="mt-10 font-heading text-6xl font-extrabold leading-none tracking-tight text-ujn-offwhite sm:text-7xl lg:text-8xl"
          >
            ±50,000
            <span className="ml-3 text-2xl font-bold text-ujn-subtle sm:text-3xl">KL</span>
          </p>
          <p className="mt-3 font-mono text-[11px] tracking-[0.22em] text-ujn-offwhite/60">
            TOTAL INSTALLED STORAGE CAPACITY
          </p>

          <div className="mt-12 divide-y divide-ujn-offwhite/10 border-y border-ujn-offwhite/10">
            {tanks.map((t) => (
              <div key={t.testId} data-testid={t.testId} className="flex items-baseline gap-6 py-5">
                <span className="w-16 font-heading text-2xl font-bold text-ujn-subtle">{t.count}</span>
                <span className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">{t.size}</span>
              </div>
            ))}
          </div>

          <p data-testid="facility-infrastructure-note" className="mt-8 max-w-md text-base leading-relaxed text-ujn-offwhite/75">
            Integrated storage tank and pumping system with tanker truck access.
          </p>
        </div>

        <Reveal delay={0.15} className="flex flex-col justify-center">
          <div className="border border-ujn-accent/30">
            <img
              src="/assets/tanks-sky.webp"
              alt="UJN bulk liquid storage tanks against the sky in Probolinggo"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="mt-4 flex items-center justify-between border border-ujn-accent/30 px-5 py-4">
            <span className="font-mono text-[10px] tracking-[0.22em] text-ujn-subtle">TANK FARM</span>
            <span className="font-mono text-[10px] tracking-[0.22em] text-ujn-offwhite/60">6 STORAGE TANKS</span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Facility;
